"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingsAndAwardsWidget = void 0;
var React = require("react");
var TrustpilotWidget_1 = require("../../../components/TrustpilotWidget");
var services_1 = require("@falcon/services");
var RatingsAndAwardsWidget = /** @class */ (function (_super) {
    __extends(RatingsAndAwardsWidget, _super);
    function RatingsAndAwardsWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RatingsAndAwardsWidget.prototype.render = function () {
        var isAllianzTier = this.props.interaction.coverTier === services_1.ALLIANZ;
        var isSilverTier = this.props.interaction.coverTier === services_1.ALLIANZ_SILVER;
        return (React.createElement("div", { className: "ratings-awards-widget" },
            React.createElement("div", null,
                React.createElement(TrustpilotWidget_1.default, null)),
            isAllianzTier && React.createElement("a", { href: "https://www.which.co.uk/money/insurance/car-insurance/car-insurance/allianz-car-insurance-review-agRiC4E7n7NP?utm_campaign=Best", target: "_blank", rel: "noopener" },
                React.createElement("img", { src: "/img/WhichLogo.png", alt: "Which logo", className: "which-logo-img" })),
            (isAllianzTier || isSilverTier) && React.createElement("img", { src: "/img/DefaqtoLogo.svg", alt: "Defaqto logo", className: "logo-img" }),
            (!isAllianzTier && !isSilverTier) && React.createElement("img", { src: "/img/DefaqtoLogo-3-star.svg", alt: "Defaqto logo", className: "logo-img" })));
    };
    return RatingsAndAwardsWidget;
}(React.Component));
exports.RatingsAndAwardsWidget = RatingsAndAwardsWidget;
//# sourceMappingURL=RatingsAndAwardsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/RatingsAndAwardsWidget.js
// module id = 3230
// module chunks = 0